import { createAsyncThunk } from '@reduxjs/toolkit';
import taxesApi from '../../../api/taxesApi';

const REDUCER_NAME = 'taxes';

export const GetTaxes = createAsyncThunk(`${REDUCER_NAME}/getTaxes`, async (scope: 'all' | 'current' | undefined, thunkAPI) => {
  const res = await taxesApi.get(scope);
  if (res.status === 200) {
    return res.data;
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const CreateTax = createAsyncThunk<any, any>(`${REDUCER_NAME}/createTax`, async (data, thunkAPI) => {
  const res = await taxesApi.create(data);
  if (res.status === 200) {
    return res.data;
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetSingleTax = createAsyncThunk<any, string>(`${REDUCER_NAME}/getSingleTax`, async (id, thunkAPI) => {
  const res = await taxesApi.getSingle(id);
  if (res.status === 200) {
    return res.data;
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const EditTax = createAsyncThunk<any, any>(`${REDUCER_NAME}/editTax`, async ({ id, data }, thunkAPI) => {
  const res = await taxesApi.edit(id, data);
  if (res.status === 200) {
    return res.data;
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const DeleteTax = createAsyncThunk<any, string>(`${REDUCER_NAME}/deleteTax`, async (id, thunkAPI) => {
  const res = await taxesApi.remove(id);
  if (res.status === 200) {
    return { ...res.data, id };
  }
  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
